export default __webpack_public_path__ + "static/media/2458_2460 ytter.fff78ce8.jpg";